<template>
  <div
    v-if="info !== null && lists && lists.length"
    :class="temp === 6 ? 'all aactive' : 'all'"
  >
    <template v-if="temp == 6">
      <div class="card-wrap">
        <div class="card-head">{{ info.title || "" }}</div>
        <div class="card-content" :class="{pbno: lists && lists.length == 1 && lists[0].type < 3}">
          <div v-for="(item, index) in lists" class="card-item" :class="{mbmore: item.type > 2 && index != lists.length -1}" :key="index">
            <div class="item-title">
              {{ item.desc
              }}<span
                >({{ que_type[item.type] }}题{{
                  item.score || score[item.type]
                }}分)</span
              >
            </div>
            <div class="pics" v-for="(imgitem, imgindex) in item.imgs" :key="imgindex">
              <img :src="imgitem" alt="" @click="prevImgs(imgitem)" />
            </div>

            <div class="videos" v-for="videoItem in item.videos" :key="videoItem.url">
              <video
                :src="videoItem.url"
                class="videos-item"
                :poster="videoItem.thumb"
                controls="controls"
              ></video>
            </div>
            <div class="card-opt-wrap" v-if="item.type < 3">
              <div
                class="card-opt-item"
                v-for="(cItem, cIndex) in item.options"
                :key="cIndex"
                @click="choose(index * 1, cIndex * 1)"
              >
                <template v-if="item.type == 1"
                  ><span
                    :class="
                      cItem.check ? 'card-checkbox active' : 'card-checkbox'
                    "
                  ></span
                ></template>
                <template v-else
                  ><span
                    :class="cItem.check ? 'card-radio active' : 'card-radio'"
                  ></span
                ></template>
                {{ item.type == 2 ? cItem.content : cItem.letter }}
              </div>
            </div>

            <div class="blanks" v-if="item.type == 3">
              <div
                class="blank-box"
                v-for="(item, index) in item.options"
                :key="index"
              >
                <div>空{{ index * 1 + 1 }}:</div>
                <p
                  class="textarea-auto"
                  style="white-space: pre-line;"
                  v-if="item.showAnswer"
                >{{ item.blank_input }}
                </p>
                <textarea
                  v-else
                  auto-height
                  style="padding: 0; height: 15px"
                  class="textarea-auto"
                  :class="{'large': fontIndex == 1}"
                  :placeholder="'请输入填空' + (index * 1 + 1) + '答案'"
                  maxlength="1000"
                  @input="inputBlank(index, lists[cI].type)"
                  ref="textareas"
                  v-model="item.blank_input"
                ></textarea>
              </div>
            </div>
            <div
              class="disscussion"
              v-if="item.type == 4"
              @click="changeCI(index)"
            >
              <p class="disscuss-textarea" v-if="item.showAnswer">
                {{ item.disscussion_input }}
              </p>
              <textarea
                class="disscuss-textarea"
                placeholder="请输入你的回答"
                placeholder-class="placeholder"
                v-model="item.disscussion_input"
                @input="inputBlank(index, item.type)"
                maxlength="3000"
                v-else
              ></textarea>
              <!-- 这还有个传图 -->
              <div class="upload-box" v-if="item.enable_img">
                <div v-if="!item.img">
                  <van-uploader
                    :before-read="beforeRead"
                    :after-read="afterRead"
                    :max-count="1"
                    accept="image/png, image/jpeg"
                    v-model="item.imgList"
                  >
                    <div class="choose-img-box">
                      <img
                        class="pic"
                        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220323/8e0a3abbd950f9f88aa1cf199177fb5f.svg"
                      />
                      <span class="choose-img-desc">图片</span>
                    </div>
                  </van-uploader>
                </div>
                <div v-else>
                  <img
                    class="pre-img"
                    @click="prevImgs(item.img)"
                    :src="
                      item.img.replace(
                        'https://cdn-xcx-qunsou.weiyoubot.cn',
                        'https://image.xiaoqiandao.com'
                      ) + '?imageMogr2/thumbnail/140x'
                    "
                    alt=""
                  />
                  <div class="btn-delete" @click="beforeDelete(index)">
                    删除
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>




    <template v-else>
      <div class="head-box">
        <div class="top">
          <div class="left">
            <span class="left-text" :style="{ color: theme_color }"
              >{{ que_type[lists[cI].type] }}题</span
            >
            <span style="color:#000"
              >{{ cI * 1 + 1
              }}<span style="color:#999">/{{ lists.length }}</span></span
            >
          </div>
          <div class="right">
            <font-setting :showFontSetting="showFontSetting" :fontIndex="fontIndex" @changeSettingShow="changeSettingShow" @changefont='changefont' />
            <div class="uFlexCenter">
              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220307/2b60729fc326c608fa1df1729e9bebec.svg"
                alt=""
                @click="submitComfirm"
              />
              <span style="color:#333;" class="pointer" @click="submitComfirm"
                >立即提交</span
              >
            </div>
          </div>
        </div>
        <van-progress
          :percentage="((cI + 1) / lists.length) * 100"
          :show-pivot="false"
          :color="theme_color"
        />
      </div>

      <div class="q" :class="fontIndex ? fontRules['do'][1] : fontRules['do'][0]">
        <div class="single_limit" v-if="single_time_limit > 0">
          <div
            :class="{
              limit_time: true,
              fillred:
                cur_single_time.finished ||
                lists[cI].t_end ||
                (cur_single_time.timeNum != '' && cur_single_time.timeNum <= 10)
            }"
          >
            <!-- <div class="limit_time_part">{{ cur_single_time.time[0] }}</div>
            <div class="limit_time_part">:</div> -->
            <div class="limit_time_part">{{ cur_single_time.time[1] }}</div>
            <div class="limit_time_part">:</div>
            <div class="limit_time_part">{{ cur_single_time.time[2] }}</div>
          </div>
          <div
            :class="{
              single_time_desc: true,
              fillred:
                cur_single_time.finished ||
                lists[cI].t_end ||
                (cur_single_time.timeNum != '' && cur_single_time.timeNum <= 10)
            }"
          >
            {{
              cur_single_time.finished || lists[cI].t_end
                ? "每题限时" + single_time_limit + "秒，本题已超时无法作答/修改"
                : "本题剩余作答时间"
            }}
          </div>
        </div>
        <div class="desc preLine">
          <span>{{ lists[cI].desc }}</span>
          <span v-if="temp != 3"
            >({{
              temp == 2 ? avg_score : lists[cI].score || score[lists[cI].type]
            }}分）</span
          >
          <label class="text-red" v-else-if="temp == 3 && lists[cI].required">*</label>
        </div>

        <div class="pics" v-for="(item, index) in lists[cI].imgs" :key="index">
          <img :src="item" alt="" @click="prevImgs(item)" />
        </div>

        <div class="videos" v-for="item in lists[cI].videos" :key="item.url">
          <video
            :src="item.url"
            class="videos-item"
            :poster="item.thumb"
            controls="controls"
          ></video>
        </div>

        <div class="blanks" v-if="lists[cI].type == 3">
          <div
            :class="
            hide_answer ? 'blank-box' :
              lists[cI].showAnswer
                ? item.correct
                  ? 'fillgreen blank-box'
                  : 'fillred blank-box'
                : 'blank-box'
            "
            v-for="(item, index) in lists[cI].options"
            :key="index"
          >
            <div style="min-width: 26px;">空{{ index * 1 + 1 }}:</div>
            <p
              class="textarea-auto"
              style="white-space: pre-line;"
              v-if="lists[cI].showAnswer"
            >{{ item.blank_input }}
            </p>
            <textarea
              v-else
              class="textarea-auto"
              :class="{'large': fontIndex == 1}"
              style="padding: 0; height: 20px"
              :style=" fontIndex == 0 ? 'height: 15px' : 'height: 33px'"
              :placeholder="'请输入填空' + (index * 1 + 1) + '答案'"
              maxlength="1000"
              @input="inputBlank(index, lists[cI].type)"
              ref="textareas"
              v-model="item.blank_input"
            ></textarea>
          </div>
        </div>

        <div
          class="options"
          v-if="
            lists[cI].type == 0 || lists[cI].type == 1 || lists[cI].type == 2
          "
        >
          <div v-for="(item, index) in lists[cI].options" :key="index" class="pb20">
            <div class="opt preLine" @click="choose(index * 1)">
              <span
                class="left"
                :class="{borderCircle: lists[cI].type != 1}"
                :style="{
                  color: item.check == 1 ? '#fff' : '#000',
                  background: item.check == 1 ? '#1890FF' : ''
                }"
                >{{ item.letter }}</span
              >
              <span
                class="right"
                :style="item.check == 1 ? 'color:#1890FF' : 'color:#000'"
                >{{ item.content }}</span
              >
            </div>
            <div class="other-fill" v-if="item.check && item.other">
              <input  
                class="textarea-auto"
                :class="{'large': fontIndex == 1}"
                style="padding: 0; height: 20px; margin-left: 0;"
                :style=" fontIndex == 0 ? 'height: 15px' : 'height: 33px'" 
                type="text" 
                placeholder="请输入补充信息" 
                maxlength='1000'
                ref="textareas"
                @input="inputBlank(index, lists[cI].type)" 
                v-model="item.blank_input" />
            </div>
          </div>
        </div>

        <div class="disscussion" v-if="lists[cI].type == 4">
          <p class="disscuss-textarea" v-if="lists[cI].showAnswer">
            {{ lists[cI].disscussion_input }}
          </p>
          <textarea
            class="disscuss-textarea"
            placeholder="请输入你的回答"
            placeholder-class="placeholder"
            v-model="lists[cI].disscussion_input"
            @input="inputBlank(0, lists[cI].type)"
            maxlength="3000"
            v-else
          ></textarea>
          <!-- 这还有个传图 -->
          <div class="upload-box" v-if="lists[cI].enable_img">
            <div v-if="!lists[cI].img">
              <van-uploader
                :before-read="beforeRead"
                :after-read="afterRead"
                :max-count="1"
                accept="image/png, image/jpeg"
                v-model="lists[cI].imgList"
              >
                <div class="choose-img-box">
                  <img
                    class="pic"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220323/8e0a3abbd950f9f88aa1cf199177fb5f.svg"
                  />
                  <span class="choose-img-desc">图片</span>
                </div>
              </van-uploader>
            </div>
            <div v-else>
              <img
                class="pre-img"
                @click="prevImgs(lists[cI].img)"
                :src="
                  lists[cI].img.replace(
                    'https://cdn-xcx-qunsou.weiyoubot.cn',
                    'https://image.xiaoqiandao.com'
                  ) + '?imageMogr2/thumbnail/140x'
                "
                alt=""
              />
              <div class="btn-delete" @click="beforeDelete">删除</div>
            </div>
          </div>
        </div>

        <div class="answer-box" v-if="show_answer_type">
          <button
            class="button confirm-btn"
            :style="{ background: theme_color }"
            @click="comfirmAnswer"
            v-if="!lists[cI].showAnswer"
          >
            确认答案
          </button>
          <div class="answer-body" v-if="lists[cI].showAnswer">
            <div class="answer" v-if="lists[cI].type != 4">
              <span class="grey" :class="fontIndex ? fontRules['do'][1] : fontRules['do'][0]">答案</span>
              <div
                class="correct-bd"
                :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]"
                v-if="
                  lists[cI].type == 0 ||
                    lists[cI].type == 1 ||
                    lists[cI].type == 2
                "
              >
                <div>
                  正确答案：<span :class="hide_answer ? '' : 'green'">{{ hide_answer ? '出题人设置隐藏' : lists[cI].correct }}</span>
                </div>
                <div>
                  我的答案：<span
                    :class="hide_answer ? 'green' : lists[cI].your_answer != lists[cI].correct ? 'red' : 'green'"
                    >{{ lists[cI].your_answer || "未作答" }}</span
                  >
                </div>
              </div>
              <div v-if="lists[cI].type == 3" class="correct-fill-content" :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]">
                <div class="grey" :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]" v-if="hide_answer">出题人设置隐藏</div>
                <template v-else>
                   <div
                    class="correct-fill preLine"
                    :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]"
                    v-for="(m, index) in lists[cI].options"
                    :key="index"
                  >空{{ index * 1 + 1 }}：<span v-for="(t, idx) in m.blank" :key="idx">
                      <span :style="idx > 0 ? 'paddingLeft: 10px' : ''" class="blank-item"
                        ><span class="blank-text" v-if="idx > 0">或</span
                        ><span style="color:#00cf97; word-break: break-all;">{{
                          t
                        }}</span></span>
                    </span>
                  </div>
                </template>
              </div>
            </div>
            <div class="answer"><span class="grey" :class="fontIndex ? fontRules['do'][1] : fontRules['do'][0]">答案解析</span></div>
            <div class="answer-desc" :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]" v-if="hide_anly">出题人设置隐藏</div>
            <template v-else>
              <div
                class="answer-desc"
                :class="fontIndex ? fontRules['do'][3] : fontRules['do'][2]"
                v-if="
                  lists[cI].answer ||
                    (!lists[cI].answer &&
                      (!lists[cI].parsing_imgs ||
                        !lists[cI].parsing_imgs.length) &&
                      (!lists[cI].parsing_items ||
                        !lists[cI].parsing_items.length))
                "
              >{{ lists[cI].answer ||
                  lists[cI].parsing_imgs.length ||
                  (lists[cI].parsing_items && lists[cI].parsing_items.length)
                    ? lists[cI].answer
                    : "无"
                }}
              </div>

              <div
                style="margin-top: 10px"
                :class="
                  lists[cI].parsing_imgs && lists[cI].parsing_imgs.length
                    ? 'mb20'
                    : ''
                "
              >
                <GzhFile
                  :jumpAble="jumpAble"
                  :fileLists="lists[cI].parsing_items || []"
                />
              </div>
              <div
                class="pics parsing-pics"
                v-for="(item, index) in lists[cI].parsing_imgs"
                :key="index"
              >
                <img :src="item" @click="prevImgs(item)"  />
              </div>
            </template>
            
          </div>
        </div>
      </div>
    </template>

    <div class="mask" v-if="showCard" @click="switchCard"></div>

    <div
      v-if="temp === 6 && card_imgs && card_imgs.length"
      :class="showCardImg ? 'foot-card-imgs active' : 'foot-card-imgs'"
    >
      <div class="top">
        <div class="l pointer" @click="switchCardImg">
          <img
            :class="
              showCardImg ? 'card-toggle-icon active' : 'card-toggle-icon'
            "
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
          />
          {{ showCardImg ? "收起" : "展开试卷内容" }}
        </div>
      </div>
      <div :class="'h800 animated ' + animationCard" style="overflow-y:scroll ">
        <div class="banner">
          <van-swipe class="my-swipe" :loop="false" indicator-color="white">
            <van-swipe-item v-for="(item, index) in card_imgs" :key="index">
              <img
                class="slide-image"
                @dragstart.prevent
                :src="item"
                alt=""
                @click="previewImage(card_imgs, index)"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>

    <div class="foot-a" id="foot-a">
      <div class="top">
        <div class="l pointer" @click="switchCard">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/7c541f3f6d664c7352805fe3ee153b3b.png"
          />
          <span>答题卡</span>
          <span v-if="time" :style="showRed ? 'color:red' : ''">{{
            time
          }}</span>
        </div>
        <div class="r">
          <template v-if="temp == 6">
            <button
              class="button pointer"
              :style="{ background: theme_color }"
              @click="submitComfirm"
            >
              提交
            </button>
          </template>
          <template v-else>
            <button
              class="button pointer"
              :style="{
                display: cI == 0 ? 'none' : 'block',
                background: theme_color
              }"
              @click="prev"
            >
              上一题
            </button>
            <button
              class="button pointer"
              :style="{ background: theme_color }"
              v-if="cI == lists.length - 1"
              @click="submitComfirm"
            >
              提交
            </button>
            <button
              class="button pointer"
              :style="{ background: theme_color }"
              v-else
              @click="next"
            >
              下一题
            </button>
          </template>
        </div>
      </div>
      <div :class="'h800 animated ' + animation" style="overflow-y:scroll ">
        <div class="box">
          <div
            v-for="(item, index) in lists"
            :key="index"
            @click="changeQ(index * 1)"
            :class="
              'choose-num ' +
                (cI == index
                  ? 'selected'
                  : '' + lists[index].hasAnswer == 1 &&
                    (temp == 0 || temp == 3 || temp == 4 || temp == 6)
                  ? 'has-choose'
                  : '' + show_answer_type &&
                    ((lists[index].type != 4 && lists[index].your_answer) ||
                      (lists[index].type == 4 && lists[index].showAnswer == 1))
                  ? lists[index].correct == lists[index].your_answer ||
                    lists[index].type == 4
                    ? 'is-right'
                    : 'is-error'
                  : '')
            "
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="coverVisible" position="bottom" @closed="coverVisible = false" z-index="102">
      <div class="minProgram-panel">
        <div class="form-container">
          <div class="form-box">
            <img
              class="avatar-icon"
              :src="join_avatar"
              @click="prevImgs(join_avatar)"
            />
            <div class="name-box" @click="showForm">
              <div class="fill-name">
                {{ name }}
              </div>
              <div class="nickedit" v-if="showEdit">
                <img
                  class="edit-icon"
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/158b6842d5dcbba4ca56d1497c7ac37c.svg"
                />
                修改
              </div>
            </div>
          </div>
          <div class="confirm-text" @click="switchCardSubmit" position="bottom">
            <template v-if="unfinished === 0">
              已完成全部作答，是否确定交卷？
            </template>
            <template v-else>
              还有
              <span class="unfinished-count">{{ unfinished }}题未作答</span>，是否确定交卷？
            </template>
          </div>
          <div class="confirm-foot">
            <div class="foot-cancel foot-btn" @click="continueAction">
              {{ unfinished === 0 ? '取消' : '查看答题卡' }}
            </div>
            <div class="foot-btn" @click="continueSubmit">确认交卷</div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="formVisible" position="bottom" @closed="formVisible = false" z-index="103">
      <div class="minProgram-panel">
        <div class="form-container nopd">
          <div class="fill-box">
            <div class="fill-title">填写答题信息</div>
            <EnrollList ref="enrollList" :has_joined="has_joined" :show_meet="show_meet" :fill_name="name" type="doPage" />
            <div class='submit-form' style="background-color:#1890FF" @click="enrollData">
              完成
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from "@/utils/api";
import uploadHttp from "@/utils/picOnly";
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog, ImagePreview } from "vant";
import {
  timestampToDate,
  getToken,
  setShareInfo,
  filterPunctuation,
  reLogin,
  deepClone,
  formatDate,
  getCacheStatus,
  getLocalTime,
  getLists,
  changeCacheStatus,
  trim,
  enQues
} from "@/utils/common";
import GzhFile from "../../components/gzhfile.vue";
import * as imageConversion from "image-conversion";
import FontSetting from "../../components/common/fontsetting.vue";
import { getDetail, cacheSubmit, translateSubmitList } from "./fn";
import { font_rules } from '@/utils/config';
import EnrollList from "@/components/elist";
import { throttle } from "lodash";
let period_timer = null;
let staging_timer = null;
let timer = null;
let interval_timer = null;
export default {
  data() {
    return {
      fontRules: font_rules,
      showFontSetting: false,
      fontIndex: 0,
      jumpAble: false,
      que_type: ["单选", "多选", "判断", "填空", "简答"],
      temp: 0,
      time: 0,
      showCard: 0,
      showCardImg: 0,
      animation: "",
      animationCard: "",
      info: null,
      cI: 0,
      info: null,
      lists: [],
      qid: "",
      timeNum: 0,
      showRed: false,
      time: timestampToDate(0),
      try: 0,
      start_time: "",
      score: "",
      staging_switch: 0,
      time_limit: 0,
      is_second_day: 0,
      isInApp: wemeet.app.isTMWebview(),
      staging_switch: 0,
      staging_data: {},
      rec_staging_id: {},
      staging_able: false,
      ques_storage: null,
      server_now: 0,
      period_count: 0,
      submitting: false,
      staging_time_count: 0,
      pre_way: 0,
      card_imgs: [],
      cur_single_time: {
        time: ["00", "00", "00"],
        finished: 0,
        timeNum: ""
      },
      single_time_limit: 0,
      theme_color: "#1890FF",
      en: '',
      coverVisible: false,
      formVisible: false,
      join_avatar: '',
      name: '',
      unfinished: 0,
      edit_form: 1,
      fill_qid: '',
      show_meet: false,
      showEdit: false,
      hide_answer: true,
      hide_anly: true,
      show_answer_type: 0,
      max_join_type: 0
    };
  },
  mounted() {
    if(localStorage.getItem('font_index')) {
      this.fontIndex = localStorage.getItem('font_index') * 1
    }
    this.info = JSON.parse(localStorage.getItem("info")) || {};
    if (!this.info) {
      if (this.$route.query.qid) {
        return this.$router.push({
          name: "normalDetail",
          query: { qid: this.$route.query.qid }
        });
      } else {
        return this.$router.push({ name: "home" });
      }
    }
    this.temp = this.info.temp;
    // this.temp = 6;
    this.qid = this.info.qid || "";
    this.try = this.$route.query.try || 0;
    this.showEdit = this.$route.query.try ? false : true;
    this.start_time = localStorage.getItem("start_time_" + this.qid);
    this.joined_count = this.info.joined_count || 0;
    this.staging_switch = this.info.staging_switch || 0;
    this.theme_color = this.info.theme_color || "#1890FF";
    this.name = this.info.join_name;
    this.join_avatar = this.info.join_avatar;
    this.edit_form = this.info.edit_form;
    this.unionid = this.info.unionid;
    this.has_joined = this.info.has_joined;
    this.meet_name = this.info.meet_name;
    this.show_answer_type = this.info.show_answer_type;
    this.hide_answer = this.info.show_answer == 1 || this.info.show_answer == 3 || this.info.show_answer == 4 || this.info.show_answer == 6 ? true : false;
    this.hide_anly = this.info.show_answer == 1 || this.info.show_answer == 2 || this.info.show_answer == 4 ? true : false;
    if(this.isInApp && localStorage.getItem("bind_status") != 1 && !this.info.reg_required) { // 腾讯会议未绑定状态下
      this.name = this.meet_name;
      this.show_meet = true;
    }
    // 如果缓存里有的话，就用缓存里的，继续走
    let self = this;
    // 走老的方法
    let ques_storage = JSON.parse(localStorage.getItem(this.qid));
    if (
      ques_storage &&
      (!ques_storage.staging_data ||
        (ques_storage.staging_data &&
          !ques_storage.staging_data.rec_staging_id))
    ) {
      this.pre_way = 1;
      this.handleHistory();
      return;
    }
    if (!self.staging_switch) {
      self.handleHistory();
    } else {
      // 走最新的方法
      getCacheStatus(self.qid).then((staging_data = {}) => {
        let { status, alert = 0, rec_staging_id = "", version } = staging_data;
        if (
          (JSON.stringify(staging_data) == "{}" || (status && alert)) &&
          !localStorage.getItem(self.qid)
        ) {
          self.staging_data = staging_data;
          self.rec_staging_id = rec_staging_id;
          self.staging_able = true;
          self.catchPeriod();
          self.handleNoList("refreshVersion");
        } else {
          let ques_storage = JSON.parse(localStorage.getItem(this.qid)) || {};
          if (
            JSON.stringify(ques_storage) != "{}" &&
            !ques_storage.staging_switch
          ) {
            self.staging_switch = 0;
            self.handleHistory("staging");
            return;
          }
          (self.staging_able = true),
            (self.staging_data = staging_data),
            (self.rec_staging_id = staging_data.rec_staging_id),
            (self.version = version);
          let { lists = {} } = staging_data;
          if (lists && JSON.stringify(lists) != "{}") {
            let stagingConfirmLen = 0;
            var copyList = [];
            for (const i in lists) {
              if (
                lists[i].videos &&
                lists[i].videos.length &&
                lists[i].videos[0].url.indexOf("mp4") > -1
              ) {
                lists[i].videoAble = true;
              }
              lists[i].options &&
                lists[i].options.map((m, i) => {
                  m.letter = String.fromCharCode(64 + parseInt(i + 1));
                });
              if (
                (lists[i].type == 0 ||
                  lists[i].type == 1 ||
                  lists[i].type == 2) &&
                lists[i].options
              ) {
                let correct = [];
                let hasOther = 0;
                for (const j in lists[i].options) {
                  if (lists[i].options[j].right == 1){
                    correct.push(lists[i].options[j].letter);
                  }
                  if(self.temp == 3 && lists[i].options[j].hasOwnProperty('blank_input')) {
                    lists[i].options[j].other = 1;
                    hasOther = 1;
                  }
                }
                lists[i].correct = correct.join("");
                lists[i].other = hasOther;
              }
              if (self.show_answer_type == 2 && lists[i].showAnswer) {
                stagingConfirmLen += 1;
              }
              copyList.push(lists[i]);
            }
            let {
              curr_index = 0,
              time_limit,
              t_start,
              time,
              t_end,
              enable_time_range,
              card_imgs = [],
              score,
              single_time_limit,
              avg_score
            } = staging_data;
            let reUpload = false;
            // 每日一练/练习模式未缓存数据处理
            if (self.show_answer_type) {
              let storage_list = ques_storage.lists || [];
              if (storage_list.length) {
                let storageConfirmLen = storage_list.filter(
                  item => item.showAnswer
                ).length;
                if (storageConfirmLen > stagingConfirmLen) {
                  reUpload = true;
                  curr_index = ques_storage.cI;
                  copyList = storage_list;
                }
              }
            }
            let _t_limit = time_limit || 0;
            // 再次进入时，根据服务端时间，计算倒计时
            let now = getLocalTime() / 1000;
            if (t_start && time_limit > 0) {
              time = time_limit * 60 - (now - t_start);
            } else if (t_start) {
              time = now - t_start;
            }
            localStorage.setItem("start_time_" + self.qid, t_start);
            self.lists = copyList;
            self.cI = curr_index;
            self.time_limit = time_limit;
            self.t_end = t_end;
            self.enable_time_range = enable_time_range;
            (self.timeNum = time > 0 ? time : 0),
              (self.avg_score = avg_score || 10),
              (self.score = score || this.info.score),
              (self.curItem = deepClone(copyList[curr_index]));
            if (self.temp == 6) {
              self.card_imgs = card_imgs || [];
            }
            self.single_time_limit = single_time_limit;
            if (single_time_limit > 0 && copyList[curr_index].t_start) {
              let timeNum =
                single_time_limit -
                (getLocalTime() - copyList[curr_index].t_start) / 1000;
              self.cur_single_time = {
                time:
                  timeNum >= 0
                    ? timestampToDate(timeNum).split(":")
                    : ["00", "00", "00"],
                timeNum,
                finished: timeNum >= 0 ? 0 : 1
              };
            }
            self.en = staging_data.en || '';
            self.max_join_type = staging_data.max_join_type || 0;

            if (self.time_limit > 0) self.startTReverse();
            else self.startT();
            // if (_t_limit > 0 && app.globalData.time_diff > _t_limit * 60)
            // self.submit(true);
            if (self.max_join_type) self.countDown("staging");
            if (!staging_timer) {
              self.catchQuesTime();
            }
            if (reUpload) self.handleCacheSubmit(1);
            self.catchPeriod();
          } else {
            if (status && !alert) {
              self.clearRepeatQues();
              let { rid, submit_type, t_start, win } = staging_data;
              let content = "答题时间已截止，已为您自动提交";
              if (submit_type == 1) {
                // 答题时间截止
                let prev_date = formatDate(t_start * 1000, "yyyy-MM-dd");
                content =
                  "您在" +
                  prev_date +
                  "日答题内容未提交，已为您自动提交，再次进入可开始新的答题";
              }
              Dialog.confirm({
                title: "温馨提示",
                content: content,
                confirmButtonColor: '#1890ff'
              }).then(() => {
                self.changeCacheStatus(self, win, rid);
              });
            } else {
              self.handleNoList("refreshVersion");
              self.catchPeriod();
            }
          }
        }
      });
    }

    this.handleRefresh();
    setShareInfo(false);
    if (!this.try) localStorage.setItem("is_submit", 0);
  },
  destroyed() {
    this.clearTimer();
    if (!this.try) {
      // not try
      // 暂存处理
      let { submitting, staging_switch } = this;
      if (!submitting && staging_switch) {
        this.handleCacheSubmit(1);
      }
      let is_submit = localStorage.getItem("is_submit");
      if (is_submit == 1) {
        localStorage.removeItem(this.qid);
        localStorage.removeItem("start_time_" + this.qid);
        localStorage.removeItem("is_submit");
      } else {
        localStorage.setItem(this.qid, JSON.stringify(this._data));
      }
    } else {
      // try
      if (localStorage.getItem(this.qid)) localStorage.removeItem(this.qid);
      if (localStorage.getItem("start_time_" + this.qid))
        localStorage.removeItem("start_time_" + this.qid);
    }
  },
  watch: {
    lists() {
      // localStorage.setItem(this.qid, JSON.stringify(this._data));
    },
    cI() {
      localStorage.setItem(this.qid, JSON.stringify(this._data));
    }
  },
  components: { Toast, Dialog, GzhFile, FontSetting, EnrollList },
  methods: {
    switchCardSubmit() {
      this.coverVisible = false;
      this.switchCard()
    },
    showForm() {
      let timer = this.fill_qid ? 0 : 100;
      if (!this.fill_qid) {
        this.fill_qid = this.fill_qid;
      }
      setTimeout(() => {
        this.formVisible = true;
      }, timer)
    },
    enrollData: throttle(
      function() {
        this.$refs.enrollList.enrollData();
      },
      2000,
      { trailing: false }
    ),
    enroll(info, enroll_alias) {
      if(info && info.length) { // 有表单信息
        let param = {
          qid: this.qid,
          unionid: this.unionid,
          access_token: getToken(),
          reg_params: info
        };
        questionOnly.post("/xcx/ques/v2/reginfo", param).then(res => {
          if(res.sta == -1 && res.errcode == 120) {
            Toast(res.msg);
          }else {
            this.name = enroll_alias;
            this.formVisible = false;
            this.coverVisible = true;
          }
        })
      }else { // 没有
        this.name = enroll_alias;
        this.formVisible = false;
        this.coverVisible = true;
        if(this.show_meet) {
          this.meet_name = enroll_alias;
        }
      }
    },
    continueAction() {
      this.coverVisible = false;
      if(this.unfinished != 0) {
        this.switchCard()
      }
    },
    continueSubmit() {
      this.submitting = true;
      this.submitQ();
    },
    showPic() {

    },
    showEditTips() {},
    changeSettingShow() {
      this.showFontSetting = !this.showFontSetting
    },
    changefont(idx) {
      this.fontIndex = idx;
      localStorage.setItem('font_index', idx);
      this.showFontSetting = false
    },
    prevImgs(val) {
      ImagePreview({
        images: [val],
        showIndex: false,
        loop: false,
        startPosition: 0
      });
    },
    previewImage(images, index) {
      ImagePreview({
        images: images,
        showIndex: true,
        loop: false,
        startPosition: index
      });
    },
    changeCI(index) {
      if (this.cI != index) this.cI = index;
    },
    inputBlank(index, type) {
      if (type == 3) {
        const textarea = this.$refs.textareas[index];
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
      let { cI } = this;
      if (this.temp === 6) cI = index;
      this.ifHasAnswer(this.lists, cI);
    },
    handleRepeatSubmit(res) {
      this.clearRepeatQues();
      Dialog.alert({
        title: "",
        message: res.msg,
        showCancelButton: false,
        confirmButtonColor: '#1890ff',
        confirmButtonText: "我知道了"
      }).then(() => {
        let { rid, is_submit } = res.data;
        if (is_submit && rid) {
          let { win, alert, status } = res.data;
          if (status && !alert) {
            this.changeCacheStatus(this, win, rid);
          } else {
            this.toResult(win, rid);
          }
        } else {
          this.$router.go(-1);
        }
      });
    },
    handleCacheSubmit(type) {
      let self = this;
      let { rec_staging_id, staging_able, pre_way } = self;
      if (!staging_able || pre_way) return;
      if (type && !rec_staging_id) {
        setTimeout(() => {
          cacheSubmit(self, type);
        }, 2000);
      } else {
        cacheSubmit(self, type);
      }
    },
    catchPeriod() {
      if (this.pre_way) return;
      //当前页面提留5分钟自动缓存一次
      if (period_timer) {
        clearInterval(period_timer);
        period_timer = null;
        this.period_count = 0;
      }
      period_timer = setInterval(() => {
        if (this.period_count >= 5 * 60 - 3) {
          this.period_count = 0;
          cacheSubmit(this, 1);
        } else {
          this.period_count = this.period_count + 3;
        }
      }, 3000);
    },
    handleHistory() {
      let ques_storage = JSON.parse(localStorage.getItem(this.qid));
      let server_now = localStorage.getItem("start_time_" + this.qid);
      if (server_now) this.server_now = server_now;
      if (ques_storage) {
        this.ques_storage = ques_storage;
        let {
          lists = [],
          cI,
          timeNum,
          time_limit,
          score,
          version,
          card_imgs = [],
          single_time_limit,
          en,
          max_join_type
        } = ques_storage;
       
        let { staging_data = {} } = this.info;
        if (
          JSON.stringify(staging_data) != "{}" &&
          !staging_data.status &&
          staging_data.rec_staging_id
        ) {
          this.rec_staging_id = staging_data.rec_staging_id;
        }
        _t_limit = time_limit;
        // 再次进入时，根据服务端时间，计算倒计时
        let now = getLocalTime() / 1000;
        if (server_now && time_limit > 0) {
          timeNum = time_limit * 60 - (now - server_now);
        } else if (server_now) {
          timeNum = now - server_now;
        }
        if (lists.length) {
          let copyList = [];
          lists.map((n, i) => {
            if (n.img && Array.isArray(n.img)) n.img = "";
            if (
              n.videos &&
              n.videos.length &&
              n.videos[0].url.indexOf("mp4") > -1
            ) {
              n.videoAble = true;
            }
            if ((n.type == 0 || n.type == 1 || n.type == 2) && n.options) {
              let correct = [];
              let hasOther = 0;
              for (const j in n.options) {
                if (n.options[j].right == 1) correct.push(n.options[j].letter);
                if(self.temp == 3 && lists[i].options[j].hasOwnProperty('blank_input')) {
                  lists[i].options[j].other = 1;
                  hasOther = 1;
                }
              }
              n.correct = correct.join("");
              n.other = hasOther;
            }
            if (single_time_limit > 0 && i == 0 && !n.t_start) {
              n.t_start = getLocalTime() + 1000;
              n.has_change = 1;
            }
            copyList.push(lists[i])
          });
          this.lists = lists;
          this.cI = cI;
          this.time_limit = time_limit;
          this.en = en;
          this.single_time_limit = single_time_limit;
          this.max_join_type = max_join_type;
          if(single_time_limit > 0) {
            this.cur_single_time = {
              timeNum: single_time_limit,
              time: timestampToDate(single_time_limit).split(':'),
              finished: 0
            }
          }
          if (single_time_limit > 0 && lists[cI].t_start) {
            let timeNum =
              single_time_limit -
              (getLocalTime() - lists[cI].t_start) / 1000;
            this.cur_single_time = {
              time:
                timeNum >= 0
                  ? timestampToDate(timeNum).split(":")
                  : ["00", "00", "00"],
              timeNum,
              finished: timeNum >= 0 ? 0 : 1
            };
          }
          (this.timeNum = timeNum > 0 ? timeNum : 0),
            (this.avg_score = this.info.avg_score || 10),
            (this.score = score);
          (this.t_end = this.info.t_end),
            (this.enable_time_range = this.info.enable_time_range),
            (this.version = version);

          if (this.temp == 6) {
            this.card_imgs = card_imgs || [];
          }
          if (this.time_limit > 0) this.startTReverse();
          else this.startT();
          if(!staging_timer && single_time_limit > 0) {
            this.catchQuesTime();
          }
          if (max_join_type) this.countDown();
          // if (_t_limit > 0 && app.globalData.time_diff > _t_limit * 60)
          // this.submit(true);
        } else {
          this.handleNoList("refreshVersion");
        }
      } else {
        this.handleNoList("refreshVersion");
      }
    },
    handleStorage(ques_storage) {
      let { lists = [], cI, score, info, qid, card_imgs = [], max_join_type } = ques_storage;
      let server_now = localStorage.getItem("start_time_" + qid);
      let time_limit = info.time_limit || 0;
      let _t_limit = time_limit;
      // 再次进入时，根据服务端时间，计算倒计时
      let now = getLocalTime() / 1000;
      let timeNum;
      if (server_now && time_limit > 0) {
        timeNum = time_limit * 60 - (now - server_now);
      } else if (server_now) {
        timeNum = now - server_now;
      }
      if (lists.length) {
        this.lists = lists;
        this.cI = cI;
        this.time_limit = time_limit;
        this.timeNum = timeNum > 0 ? parseInt(timeNum) : 0;
        this.t_end = info.t_end;
        this.enable_time_range = info.enable_time_range;
        this.version = info.version;
        this.score = score;
        this.max_join_type = max_join_type;
        if (this.temp == 6) {
          this.card_imgs = card_imgs || [];
        }
        if (this.time_limit > 0) this.startTReverse();
        else this.startT();
        if (_t_limit > 0) {
          if (server_now - getLocalTime() / 1000 > _t_limit * 60) {
            this.submitQ(true);
          }
        }
        if (max_join_type) this.countDown();
      } else {
        this.handleNoList("refreshVersion");
      }
    },
    handleRefresh() {
      let self = this;

      window.onbeforeunload = function(e) {
        if (self.$route.name === "doNormal") {
          let { submitting, staging_switch, staging_able, pre_way } = self;
          if (!submitting && staging_switch && staging_able && !pre_way) {
            self.handleCacheSubmit(1);
          }
          localStorage.setItem(self._data.qid, JSON.stringify(self._data));
          e = e || window.event;
          // 兼容IE8和Firefox 4之前的版本
          if (e) {
            e.returnValue = "确定离开当前页面吗？";
          }
        } else {
          window.onbeforeunload = null;
        }
      };
    },
    comfirmAnswer() {
      const index = this.cI;
      let lists = deepClone(this.lists) || [];
      const type = lists[index] ? lists[index].type : 1;
      if (lists[index] && lists[index].hasAnswer == 1) {
        this.handleComfirmAnswer(lists, index);
      } else {
        let tips = "选择";
        if (type == 4 || type == 3) tips = "填写";
        Toast("请" + tips + "答案");
      }
    },
    handleComfirmAnswer(lists, index) {
      lists[index].showAnswer = 1;
      lists[index].has_change = 1;
      let _type = lists[index].type;
      if (_type == 3) {
        let opt = lists[index].options,
          len = opt.length,
          right_count = 0,
          order_answer = lists[index].order_answer;
        if (order_answer) {
          try {
            var opt_right_list = [];
            let blank_map = {};
            let opt_idx_map = {};
            let curr_options = opt || [];
            for (let curr_idx = 0; curr_idx < curr_options.length; curr_idx++) {
              opt_idx_map[curr_idx] = 1;
              let curr_opt = curr_options[curr_idx];
              let blanks = curr_opt["blank"] || [];
              for (let j = 0; j < blanks.length; j++) {
                let blank_item = blanks[j];
                let r_blank = filterPunctuation(trim(blank_item));
                if (!blank_map.hasOwnProperty(r_blank)) {
                  blank_map[r_blank] = [];
                }
                blank_map[r_blank].push(curr_idx);
              }
            }
            for (var options_idx = 0; options_idx < opt.length; options_idx++) {
              var options_item = opt[options_idx];
              let blank_input = options_item["blank_input"];
              var temp_input = filterPunctuation(trim(blank_input));
              if (blank_map[temp_input]) {
                var idx_list = blank_map[temp_input];
                opt_right_list.push({
                  count: idx_list.length,
                  idx_list: idx_list,
                  opt_index: options_idx
                });
                if (!idx_list.length) {
                  options_item["correct"] = 0;
                  continue;
                }
                options_item["correct"] = 1;
              } else {
                options_item["correct"] = 0;
              }
            }
            opt_right_list.sort(function(x, y) {
              return parseInt(x["count"]) - parseInt(y["count"]);
            });
            var used_idx_set = new Set();
            for (var i = 0; i < opt_right_list.length; i++) {
              var opt_item = opt_right_list[i];
              if (!opt_item["idx_list"]) {
                continue;
              }
              var opt_index = opt_item["opt_index"];
              var use_idxs = new Set(opt_item["idx_list"]);
              var use_idx_list = new Set(
                [...use_idxs].filter(x => !used_idx_set.has(x))
              );
              if (!use_idx_list.size) {
                lists[index].options[opt_index]["correct"] = 0;
                continue;
              }
              var use_idx = Array.from(use_idx_list)[0];
              used_idx_set.add(use_idx);
              lists[index].options[opt_index]["correct"] = 1;
              right_count += 1;
            }
          } catch (error) {}
        } else {
          for (const i in opt) {
            let temp_m = [];
            opt[i].blank && opt[i].blank.map(item => {
              temp_m.push(filterPunctuation(item));
            });
            const temp_input = filterPunctuation(opt[i].blank_input || "");
            if (temp_m.indexOf(temp_input) > -1)
              (opt[i].correct = 1), right_count++;
            else opt[i].correct = 0;
          }
        }
        if (len == right_count) {
          lists[index].your_answer = 1;
          lists[index].correct = 1;
        } else {
          lists[index].your_answer = 1;
          lists[index].correct = 0;
        }
      }
      if (_type <= 2) {
        let opt = lists[index].options,
          your_answer = [];
        for (const i in opt) {
          if (opt[i].check) your_answer.push(opt[i].letter);
        }
        lists[index].your_answer = your_answer.join("");
      }
      this.lists = lists;
    },
    beforeRead(file) {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      const isLt1M = (file.size / 1024 / 1024) * 10 < 5;
      if (!isLt1M) {
        let myImg = new Promise(resolve => {
          // 压缩到500KB,这里的500就是要压缩的大小,可自定义
          imageConversion.compressAccurately(file, 500).then(res => {
            resolve(res);
          });
        });
        return myImg;
      }
      return true;
    },
    afterRead(file) {
      var url = api.question.upload;
      let formData = new window.FormData();
      formData.append("file", file.file);
      formData.append("access_token", getToken());
      try {
        uploadHttp.post(url, formData).then(res => {
          let copy = deepClone(this.lists);
          copy[this.cI].img = res.data.urls[0];
          copy[this.cI].imgList = [res.data.urls[0]];
          copy[this.cI].has_change = 1;
          this.lists = copy;
          this.$store.commit("changeLoading", { status: false });
        });
      } catch (e) {
        this.$store.commit("changeLoading", { status: false });
      }
    },
    beforeDelete(cI = 0) {
      let copyData = deepClone(this.lists);
      if (this.temp !== 6) cI = this.cI;
      copyData[cI].img = "";
      copyData[cI].imgList = [];
      copyData[cI].has_change = 1;
      this.lists = copyData;
      // this.lists[this.cI].img = "";
    },
    getList(lists) {
      for (const i in lists) {
        let item = lists[i];
        if (item.type == 0 || item.type == 1 || item.type == 2) {
          let correct = [];
          for (const j in item.options) {
            if (item.options[j].right == 1)
              correct.push(item.options[j].letter);
          }
          item.correct = correct.join("");
        }
        if (item.type === 4) {
          if (item.enable_img) {
            item.imgList = [];
          }
        }
      }
      return lists;
    },
    handleNoList(refreshVersion) {
      let self = this;
      getDetail(self).then(res => {
        let {
          lists,
          score = { 0: 10, 1: 10, 2: 10, 3: 10, 4: 10 },
          version,
          enable_time_range,
          t_end,
          single_time_limit,
          max_join_type
        } = res;
        // 简答题图片兼容及视频是否违规判断
        lists.map((n, i) => {
          if (n.img && Array.isArray(n.img)) n.img = "";
          if (
            n.videos &&
            n.videos.length &&
            n.videos[0].url.indexOf("mp4") > -1
          ) {
            n.videoAble = true;
          }
          if (n.options && n.options.length > 0) {
            n.options &&
              n.options.map((m, i) => {
                m.check = 0;
                m.letter = String.fromCharCode(64 + parseInt(i + 1));
              });
          }
          if ((n.type == 0 || n.type == 1 || n.type == 2) && n.options) {
            let correct = [];
            let hasOther = 0;
            for (const j in n.options) {
              if (n.options[j].right == 1) correct.push(n.options[j].letter);
              if(self.temp == 3 && lists[i].options[j].hasOwnProperty('blank_input')) {
                lists[i].options[j].other = 1;
                hasOther = 1;
              }
            }
            n.correct = correct.join("");
            n.other = hasOther;
          }
          if (single_time_limit > 0 && i == 0 && !n.t_start) {
            n.t_start = getLocalTime() + 1000;
            n.has_change = 1;
          }
        });
        // lists = util.getLists(lists);
        // 缓存处理
        let { staging_data = {}, staging_switch } = res;
        // staging_switch = 0;
        var time_limit = self.info.time_limit;
        let _t_limit = time_limit;
        self.staging_data = staging_data;
        self.staging_switch = staging_switch;
        self.lists = lists;
        (self.curItem = deepClone(lists[0])), (self.time_limit = time_limit);
        (self.timeNum = time_limit > 0 ? time_limit * 60 : 1),
          (self.enable_time_range = enable_time_range);
        self.t_end = t_end;
        self.avg_score = self.info.avg_score || 10;
        self.score = score;
        if (self.temp == 6) self.card_imgs = res.card_imgs || [];
        self.single_time_limit = single_time_limit || 0;
        if (single_time_limit > 0) {
          self.cur_single_time = {
            timeNum: single_time_limit,
            time: timestampToDate(single_time_limit).split(":"),
            finished: 0
          };
        }
        self.en = staging_data && staging_data.en ? staging_data.en : res.en;
        self.max_join_type = max_join_type;
        if (staging_switch && staging_data.rec_staging_id) {
          self.rec_staging_id = staging_data.rec_staging_id;
        }
        if (refreshVersion) self.version = version;
        if (staging_switch) {
          let { status } = staging_data;
          if (JSON.stringify(staging_data) === "{}" || status) {
            self.handleCacheSubmit(0);
          }
          if (!staging_timer) {
            self.catchQuesTime();
          }
        } else {
          // 老的方法但是缓存里有未提交的数据
          if(!staging_timer && single_time_limit > 0) {
            self.catchQuesTime();
          }
          if (
            JSON.stringify(staging_data) != "{}" &&
            !staging_data.status &&
            staging_data.rec_staging_id
          ) {
            self.rec_staging_id = staging_data.rec_staging_id;
          }
        }
        // 正常为计时，特别为倒计时
        if (self.time_limit > 0) self.startTReverse();
        else self.startT();
        if (max_join_type) self.countDown(staging_switch ? "staging" : "");
        // 如果时间超了，再次进入时，直接提交答题内容
        // if (_t_limit > 0 && app.globalData.time_diff > _t_limit * 60)
        //   self.submit(true);
      });
    },
    startT() {
      let { enable_time_range, t_end, submitting } = this;
      if (!submitting) {
        timer = setInterval(() => {
          this.timeNum = this.timeNum * 1 + 1;
          this.time = timestampToDate(this.timeNum * 1);
          if (enable_time_range) {
            if (t_end - 2 <= getLocalTime() / 1000) {
              clearInterval(timer);
              this.submitting = true;
              this.submitQ(true, 3);
            }
          }
        }, 1000);
      }
    },
    startTReverse() {
      let { enable_time_range, t_end, submitting } = this;
      if (!submitting) {
        timer = setInterval(() => {
          this.timeNum = this.timeNum * 1 - 1;
          this.time = timestampToDate(this.timeNum * 1);
          this.showRed = this.timeNum < 60 ? true : false;
          if (this.timeNum <= 0) {
            // 倒计时模式
            clearInterval(timer);
            this.time = timestampToDate(0);
            this.submitting = true;
            this.submitQ(true, 2);
            return;
          }
          if (enable_time_range && t_end - 2 <= getLocalTime() / 1000) {
            clearInterval(timer);
            this.submitting = true;
            this.submitQ(true, 3);
            return;
          }
        }, 1000);
      }
    },
    handleJumpPage(preIndex, nextIndex) {
      let { lists, single_time_limit } = this;
      if (single_time_limit > 0) {
        if (lists[preIndex].hasAnswer || lists[preIndex].t_end) {
          this.handleNextLimit(nextIndex);
          this.jumpSecond(nextIndex);
        } else {
          Dialog.confirm({
            message:
              "该题限时作答，离开后仍会计时超时后无法作答/修改，是否要进入下一题？",
            confirmButtonText: "继续作答",
            cancelButtonText: "下一题",
            confirmButtonColor: "#1890ff"
          })
            .then(async () => {
              // 确认
            })
            .catch(() => {
              // 取消
              this.handleModalNext(nextIndex);
            });
        }
      } else {
        this.jumpSecond(nextIndex);
      }
    },
    handleModalNext(nextIndex) {
      this.handleNextLimit(nextIndex);
      this.jumpSecond(nextIndex);
    },
    submitComfirm() {
      let { lists } = this;
      let { temp } = this.info;
      let hasAnswer = lists.filter(item => {
        return item.hasAnswer == 1;
      });
      if (temp == 3) {
        let required_kong = -1; // 必填项是否已填写
        for (const i in lists) {
          let item = lists[i];
          if (!item.hasAnswer && item.required) {
            required_kong = parseInt(i);
            break;
          }
        }
        if (required_kong > -1) {
          Dialog.alert({
            title: "提示",
            confirmButtonColor: '#1890ff',
            confirmButtonText: '我知道了',
            message: `第${required_kong + 1}题为必填项，请前往填写`
          }).then(() => {});
          return;
        }
      }
      let txt,
        btn_text = temp == 3 ? "提交" : "交卷";
      if (hasAnswer.length == lists.length)
        txt = `已完成全部题目，是否确定${btn_text}`;
      else txt = `还未完成全部题目，是否确定${btn_text}`;
      this.unfinished = lists.length - hasAnswer.length;
      this.coverVisible =  true;
      return;
      Dialog.confirm({
        title: "确认",
        message: txt,
        confirmButtonColor: '#1890ff'
      })
        .then(() => {
          this.submitting = true;
          this.submitQ();
        })
        .catch(() => {});
    },
    submitQ(countDown, countDownType = 0) {
      var self = this;
      var { lists } = this;
      let listsData = translateSubmitList(this, lists);
      let server_now = localStorage.getItem("start_time_" + this.qid);
      let obj = { optC: listsData.optC };
      let bind_status = localStorage.getItem("bind_status") || 0;
      var data = {
        qid: this.qid,
        lists: obj.optC,
        time:
          self.time_limit > 0
            ? self.time_limit * 60 - self.timeNum
            : self.timeNum,
        access_token: getToken(),
        version: self.version,
        is_force: countDown || self.is_second_day ? 1 : 0,
        t_start: server_now > 0 ? parseInt(server_now) : 0,
        show_answer: self.info.show_answer || 0,
        ...(self.isInApp && bind_status != 1
          ? { meet_name: self.meet_name || "" }
          : {}),
        version_code: 1,
        xcx_version: "1.0.0",
        ...(self.try ? { source: "meet_temp" } : {
          rec_staging_id: self.rec_staging_id && !self.pre_way ? self.rec_staging_id : "",
        }),
        submit_source: self.isInApp ? 2 : 1,
        ...self.en ? { en: enQues(self.en) } : {}
      };
      if (countDownType || self.is_second_day) {
        // submit_type自动提交类型 1: 跨天 2: 倒计时 3: 答题时间段
        data.submit_type = self.is_second_day ? 1 : countDownType;
      }
      questionOnly
        .post("/xcx/ques/v2/submit", data)
        .then(res => {
          if (res.sta == 0) {
            if (timer) clearInterval(timer);
            if (interval_timer) clearInterval(interval_timer);
            if (staging_timer) clearInterval(staging_timer);
            if (period_timer) clearInterval(period_timer);

            localStorage.removeItem("count_down_time_" + this.qid);
            if (localStorage.getItem(this.qid))
              localStorage.removeItem(this.qid);
            localStorage.setItem("is_submit", 1);
            let name = self.try ? "resultTry" : "normalResult";
            let query = self.try
              ? { qid: self.info.qid }
              : { rid: res.data.rid };
            if (self.try) {
              localStorage.setItem("tryResult", JSON.stringify(res.data));
            }
            if (self.is_second_day) {
              let now_time = getLocalTime() / 1000;
              let server_now = self.start_time;
              if (now_time - server_now > 60 * 60 && server_now) {
                let prev_date = formatDate(server_now * 1000, "yyyy-MM-dd");
                Dialog.alert({
                  message:
                    "您在" +
                    prev_date +
                    "日答题内容未提交，已为您自动提交，再次进入可开始新的答题"
                }).then(() => {
                  localStorage.setItem("_win", res.data.win);
                  this.$router.replace({ name: name, query: query });
                });
              } else {
                Dialog.alert({
                  message:
                    "每日一练每天0点刷新，今天的练习已经结束。自动为你提交试卷，重新进入开始新的挑战！"
                }).then(() => {
                  localStorage.setItem("_win", res.data.win);
                  this.$router.replace({ name: name, query: query });
                });
              }
            } else if (countDown == 1) {
              Dialog.alert({
                title: "提示",
                message: "答题时间已截止，已为您自动提交"
              }).then(() => {
                localStorage.setItem("_win", res.data.win);
                this.$router.replace({ name: name, query: query });
              });
            } else {
              localStorage.setItem("_win", res.data.win);
              this.$router.replace({ name: name, query: query });
            }
          } else if (res.sta == -500) {
            reLogin();
          } else if (res.sta == -1 && res.errcode == 108) {
            this.submitting = false;
            this.handleRepeatSubmit(res);
          } else {
            this.submitting = false;
            Toast(res.msg);
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    translateSubmitList(lists, cache, type) {
      let optC = {},
        tmp_qqids = [];
      lists.map((n, j) => {
        if (type) {
          j = n.oriIndex;
        }
        optC[j] = {};
        tmp_qqids.push(n.qqid || n.id);
        optC[j]["id"] = n.qqid ? n.qqid : n.id;
        optC[j]["show_order"] = n.options;
        optC[j]["img"] = n.img;
        optC[j]["type"] = n.type;
        optC[j]["parsing_imgs"] = n.origin_parsing_imgs
          ? n.origin_parsing_imgs
          : n.parsing_imgs;
        if (n.parsing_items) {
          optC[j]["parsing_items"] = n.parsing_items;
        }
        optC[j]["imgs"] = n.origin_imgs ? n.origin_imgs : n.imgs;
        optC[j]["answer"] = n.answer;
        optC[j]["options"] = n.options;
        optC[j]["desc"] = n.desc;
        if (n["score"]) {
          optC[j]["score"] = n.score;
        }
        if (n.videos) {
          n.videos.map(item => {
            item.thumb = item.origin_thumb ? item.origin_thumb : item.thumb;
            delete item.origin_thumb;
          });
          optC[j]["videos"] = n.videos;
        }
        if (cache) {
          optC[j]["your_answer"] = n.your_answer;
          optC[j]["hasAnswer"] = n.hasAnswer;
          if (
            this.show_answer_type ||
            this.single_time_limit > 0
          ) {
            optC[j]["showAnswer"] = n.showAnswer;
          }
          if (this.temp === 3) {
            optC[j]["required"] = n.required;
          }
          if (n.type === 4) {
            optC[j]["enable_img"] = n.enable_img;
          }
          if (
            n.videos &&
            n.videos.length &&
            n.videos[0].url.indexOf("mp4") > -1
          ) {
            n.videoAble = true;
          }
        }
        if (n.type === 4) {
          // 简答题
          optC[j]["opt"] = [];
          optC[j]["opt"].push(n.disscussion_input || "");
          if (cache) {
            optC[j]["disscussion_input"] = n.disscussion_input;
          }
        }
        if (n.type === 3) {
          optC[j]["order_answer"] = n.order_answer || 0;
        }
        if (this.single_time_limit && this.single_time_limit > 0) {
          optC[j]["t_start"] = n.t_start;
        }
      });
      return { optC, tmp_qqids };
    },
    choose(index, cIndex) {
      let { temp } = this;
      let lists = deepClone(this.lists);
      let cI = temp == 6 ? index : this.cI;
      if (temp == 6) index = cIndex;
      if (
        (this.show_answer_type || this.single_time_limit > 0) &&
        lists[cI].showAnswer
      ) {
        return;
      }
      if (lists[cI].type == 1) {
        const { options = [] } = lists[cI];
        if (options && options[index]) {
          lists[cI].options[index].check = options[index].check ? 0 : 1;
        }
      }
      if (lists[cI].type == 0 || lists[cI].type == 2) {
        lists[cI].options.map((n, i) => {
          n.check = 0;
        });
        if (lists[cI].options[index]) lists[cI].options[index].check = 1;
      }
      this.lists = lists;
      this.ifHasAnswer(lists, cI);
      this.$forceUpdate();
    },
    jumpSecond(cI) {
      let { staging_switch, staging_able, lists, pre_way } = this;
      this.cI = cI;
      this.curItem = deepClone(lists[cI]);
      if (staging_switch && staging_able && !pre_way) {
        this.clearStagingTime();
        this.catchQuesTime();
      }
    },
    prev() {
      let {
        cI,
        lists,
        staging_switch,
        staging_able,
        pre_way,
        single_time_limit
      } = this;
      this.cI = cI * 1 - 1;
      if (single_time_limit && single_time_limit > 0) {
        this.handleNextLimit(cI * 1 - 1);
      }
      this.curItem = deepClone(lists[cI * 1 - 1]);
      if (staging_switch && staging_able && !pre_way) {
        this.clearStagingTime();
        this.catchQuesTime();
      }
    },
    next() {
      let { cI } = this;
      this.handleJumpPage(cI, cI * 1 + 1);
    },
    changeQ(index) {
      // document.querySelector(".all").scrollTop = 0
      // clientTop
      if (this.temp == 6) {
        let top = document.querySelectorAll(".card-item")[index].offsetTop;
        document.querySelector(".all").scrollTo({
          top,
          behavior: "smooth"
        });
      }
      this.handleJumpPage(this.cI, index);
      this.switchCard();
    },
    switchCard() {
      this.animation = this.showCard ? "hideAction" : "showAction";
      this.showCard = this.showCard ? 0 : 1;
    },
    switchCardImg() {
      this.animationCard = this.showCardImg ? "hideActionImg" : "showActionImg";
      this.showCardImg = this.showCardImg ? 0 : 1;
    },
    ifHasAnswer(lists, index) {
      lists = deepClone(lists);
      var { cI } = this;
      if (this.temp == 6) cI = index;
      var lists = lists || deepClone(this.lists);
      if (lists[cI].type == 4) {
        if (lists[cI].disscussion_input) {
          lists[cI].hasAnswer = 1;
          lists[cI].your_answer = 1;
        } else lists[cI].hasAnswer = 0;
      } else {
        const { options = [] } = lists[cI];
        let hasAnswer;
        if(this.temp !=3 || lists[cI].type > 1 || !lists[cI].other) {
          hasAnswer = options.filter(item => {
            return item.check == 1 || item.blank_input;
          });
          if (hasAnswer.length > 0) lists[cI].hasAnswer = 1;
          else lists[cI].hasAnswer = 0;
        }else {
          // 判断是否有任何普通选项被选中
          const hasNormalAnswer = options.some(item => !item.other && item.check == 1);
          // 判断是否有 other 选项被选中但未填写 blank_input
          const hasInvalidOther = options.some(item => 
            item.other && item.check == 1 && trim(item.blank_input) === ''
          );
          // 如果是必填题，且存在无效的 other 选项，则整体无效
          if (lists[cI].required && hasInvalidOther) {
            hasAnswer = 0;
          } 
          // 否则，只要有任何普通选项或有效的 other 选项，就算有效
          else {
            hasAnswer = (hasNormalAnswer || options.some(item => 
              item.other && item.check == 1 && trim(item.blank_input) !== ''
            )) ? 1 : 0;
          }
          lists[cI].hasAnswer = hasAnswer ? 1 : 0;
        } 
      }
      lists[cI].has_change = 1;
      this.lists = lists;
    },
    countDown(type) {
      let t_start = 0;
      if (type) {
        // 新的方法staging
        let { staging_data = {} } = this;
        let { status } = staging_data;
        if (!status) {
          t_start = staging_data.t_start * 1000;
        }
      }
      let date = type
        ? t_start
        : localStorage.getItem("count_down_time_" + this.qid) || 0;
      let m1; // 开始的时间戳
      if (date > 0) {
        m1 = new Date(date).getTime();
      } else {
        m1 = new Date(getLocalTime()).getTime()
        localStorage.setItem("count_down_time_" + this.qid, m1) ;
      }
      let self = this;
      interval_timer = setInterval(function() {
        let now = getLocalTime();
        // 判断是否为同一天的答题
        if (!self.isSameDay(now, m1)) {
          self.is_second_day = 1;
          self.submitting = true;
          self.submitQ();
          clearInterval(interval_timer);
          interval_timer = null;
        }
      }, 1200);
    },
    isSameDay(timestamp1, timestamp2) {
      const date1 = new Date(timestamp1);
      const date2 = new Date(timestamp2);
      return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
    },
    clearTimer() {
      if (staging_timer) this.clearStagingTime();
      if (period_timer) {
        clearInterval(period_timer);
        period_timer = null;
        this.period_count = 0;
      }
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (interval_timer) {
        clearInterval(interval_timer);
        interval_timer = null;
      }
    },
    clearStagingTime() {
      clearInterval(staging_timer);
      staging_timer = null;
      this.staging_time_count = 0;
      this.cur_single_time = {
        ...this.cur_single_time,
        timeNum: ""
      };
    },
    clearRepeatQues() {
      localStorage.removeItem(this.qid);
      this.clearTimer();
      this.staging_able = false;
    },
    changeCacheStatus(self, win, rid) {
      changeCacheStatus(self.qid, self.rec_staging_id).then(() => {
        this.toResult(win, rid);
      });
    },
    catchQuesTime() {
      if (this.temp == 6) return;
      if(staging_timer) {
        clearInterval(staging_timer);
        staging_timer = null
      }
      let {
        cI,
        staging_time_count,
        untiCheating_change,
        single_time_limit,
        staging_able
      } = this;
      if (this.lists[cI] &&(staging_able || single_time_limit > 0)) {
        staging_timer = setInterval(() => {
          let { lists } = this;
          if (staging_able) {
            // let type = lists[cI].type;
            let able_time = 60;
            if (
              staging_time_count >= able_time &&
              (lists.filter(item => item.has_change).length ||
                untiCheating_change)
            ) {
              cacheSubmit(this, 1);
              this.clearStagingTime();
              this.catchQuesTime();
            } else {
              this.staging_time_count = this.staging_time_count + 1;
              if (staging_time_count > 3600) {
                this.clearStagingTime();
              }
            }
          }
          // 单题计时操作
          if (single_time_limit && single_time_limit > 0) {
            if (lists[cI].t_start) {
              // 如果之前存了当前单个题的开始时间 用当前时间减去开始时间获取剩余的时间
              if (!lists[cI].t_end) {
                // 未结束
                let timeNum = this.cur_single_time.timeNum;
                if (timeNum == "") {
                  // 上一级清除过需要重新计算
                  timeNum =
                    single_time_limit -
                    (getLocalTime() - lists[cI].t_start) / 1000 -
                    1;
                } else {
                  timeNum = this.cur_single_time.timeNum - 1;
                }
                if (timeNum <= 0) {
                  // 当前单题计时已截止
                  lists[cI].t_end = 1;
                  if (this.temp != 2 && this.temp != 1) {
                    lists[cI].showAnswer = 1;
                  }
                  if (this.show_answer_type && !lists[cI].showAnswer) {
                    this.handleComfirmAnswer(lists, cI);
                  } else {
                    this.lists = lists;
                  }
                }
                this.cur_single_time = {
                  time:
                    timeNum >= 0
                      ? timestampToDate(timeNum).split(":")
                      : ["00", "00", "00"],
                  timeNum,
                  finished: timeNum >= 0 ? 0 : 1
                };
              }
              } else {
                // 当前答题没有存储开始时间
                this.handleNoSingleStart(cI, single_time_limit, lists);
              }
            }
        }, 1000);
      }
    },
    // 处理下一题单个计时数据
    handleNextLimit(nextIndex) {
      let { lists, single_time_limit } = this;
      if (single_time_limit > 0) {
        if (lists[nextIndex].t_start) {
          // 如果之前存了当前单个题的开始时间 用当前时间减去开始时间获取剩余的时间
          let timeNum =
            single_time_limit -
            (getLocalTime() - lists[nextIndex].t_start) / 1000;
          this.cur_single_time = {
            time:
              timeNum >= 0
                ? timestampToDate(timeNum).split(":")
                : ["00", "00", "00"],
            timeNum,
            finished: timeNum >= 0 ? 0 : 1
          };
        } else {
          // 当前答题没有存储单题的开始时间
          this.handleNoSingleStart(nextIndex, single_time_limit, lists);
        }
      }
    },
    // 当前答题没有存储单题开始时间
    handleNoSingleStart(cI, single_time_limit, lists) {
      let curTime = getLocalTime();
      lists[cI].t_start = curTime + 2000;
      lists[cI].has_change = 1;
      this.lists = lists;
      this.cur_single_time = {
        time: timestampToDate(single_time_limit).split(":"),
        timeNum: single_time_limit,
        finished: 0
      };
    },
    toResult(win, rid, res) {
      localStorage.setItem("_win", win);
      let name = this.try ? "resultTry" : "normalResult";
      let query = this.try ? { qid: this.qid } : { rid: rid };
      if (this.try) {
        localStorage.setItem("tryResult", JSON.stringify(res.data));
      }
      this.$router.replace({ name: name, query: query });
    }
  }
};
</script>

<style scoped lang="scss">
.uFlexCenter {
  display: flex;
  align-items: center;
}
.all {
  min-height: 100vh;
  background: #fff;
  color: #262626;
  padding-bottom: 100px;
  height: auto;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
  font-size: 14px;
}
.all.aactive {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 0;
  background: #F2F2F7;
}
.foot-a {
  position: fixed;
  background-color: #fff;
  border-top: 1px solid #eee;
  bottom: 0;
  z-index: 101;
  box-sizing: content-box;
  left: auto;
  max-width: 500px;
  min-width: 320px;
  width: 100%;
}
.head-box {
  padding: 0 15px;
  position: fixed;
  top: 0;
  height: 70px;
  max-width: 500px;
  min-width: 320px;
  width: 100%;
  // width: calc(100vw - 15px);
  left: auto;
  background-color: #fff;
  box-sizing: border-box;
}

.head-box .top {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-size: 15px;
  .left-text {
    padding-right: 6px;
    color: #1890ff;
    font-size: 16px;
  }
}

.head-box .top .right {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  font-size: 15px;
}

.head-box .top .right img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-left: 15px;
}

.foot-a .top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px;
  right: 15px;
  left: 15px;
}

.foot-a .top .l,
.foot-a .top .r {
  display: flex;
  align-items: center;
}
.foot-a .top .r {
  margin-right: 30px;
}

.foot-a .top .l {
  font-size: 15px;
  height: 20px;
  line-height: 20px;
}

.foot-a .top .l img {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.foot-a .top .l span {
  padding-right: 5px;
}

.button {
  height: 30px;
  width: 84px;
  margin: 0;
  margin-left: 10px;
  font-size: 15px;
  line-height: 30px;
  border-radius: 4px;
  color: #fff;
}

.h800 {
  height: 0;
  // border-top: 1px solid #eee;
}

/* 动画？ */
.h800 .box {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  padding: 10px 0;
  justify-content: flex-start;
}

.choose-num {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  background-color: #eee;
  margin: 13px;
}

.has-choose {
  background-color: #caeefc;
  color: #1890ff;
}

.is-right {
  background-color: #ccffe3;
  color: #00cf97;
}
.is-error {
  background-color: #ffcccc;
  color: #ff5c5c;
}

.selected {
  background-color: #1890ff;
  color: #fff;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes showAction {
  from {
    height: 0;
  }

  to {
    height: 200px;
  }
}

.showAction {
  animation-name: showAction;
  animation-duration: 0.5s;
}

@keyframes hideAction {
  from {
    height: 200px;
  }

  to {
    height: 0;
  }
}

.hideAction {
  animation-name: hideAction;
  animation-duration: 0.3s;
}
//

@keyframes showActionImg {
  from {
    height: 0;
  }

  to {
    height: 200px;
  }
}

.showActionImg {
  animation-name: showActionImg;
  animation-duration: 0.5s;
}

@keyframes hideActionImg {
  from {
    height: 200px;
  }

  to {
    height: 0;
  }
}

.hideActionImg {
  animation-name: hideActionImg;
  animation-duration: 0.3s;
}

.num {
  font-size: 15px;
}

.num span {
  color: #666;
}

.q {
  padding: 70px 15px 20px;
  line-height: 1.4;
  background-color: #fff;
}

.desc {
  padding: 10px 0 25px;
}
.text-red {
  color: #ff5c5c;
  padding: 0 10px;
}

.pics img {
  width: 100%;
  margin-bottom: 10px;
}

.pics img:last-child {
  margin-bottom: 20px;
}
.parsing-pics {
  margin-top: 10px;
}

.opt {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.opt .left {
  height: 36px;
  min-width: 36px;
  border-radius: 4px;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  background-color: #eee;
  margin-right: 10px;
}

.opt .right {
  flex: 1;
  word-break: break-all;
}
.pb20 {
  padding-bottom: 20px;
}

/* 填空 */
.blank-box {
  border: 1px solid #eee;
  background-color: #fafafa;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  margin-bottom: 15px;
  padding: 10px 15px;
}

.blank-box view {
  color: #000;
}

.textarea-auto {
  min-height: 22px;
  line-height: 22px !important;
  // height: 43px;
  word-break: break-all;
  flex: 1;
  margin-left: 10px;
  border: none;
  resize: none;
}
.textarea-auto.large {
  line-height: 34px !important;
}

.textarea-place, .placeholder {
  color: #999;
}
.disscuss-textarea {
  display: block;
  background-color: #fafafa;
  width: 100%;
  padding: 15px;
  border: none;
  min-height: 100px;
  box-sizing: border-box;
  resize: none;
}

/* answer-box */
.answer-box {
  margin: 0 -15px;
}
.confirm-btn {
  width: calc(100% - 30px);
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  margin: 15px 15px 0;
  display: block;
}
.answer-body {
  padding: 0 15px;
  background-color: #fff;
  margin-top: 10px;
  border-top: 10px solid #f2f2f7;
}
.answer .grey {
  display: block;
  color: #333;
  font-size: 16px;
  padding-top: 15px;
}
.correct-fill {
  color: #666;
  font-size: 14px;
  margin: 10px 0;
  display: flex;
  align-items: center;
}
.correct-fill:last-child {
  margin-bottom: 0;
}
.correct-fill div {
  padding-top: 10px;
}
.correct-bd {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  padding: 10px 0 15px;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
}
.correct-bd div {
  padding-right: 25px;
}
.correct-bd .green,
.correct-fill .green {
  color: #00cf97;
}
.correct-bd .red,
.correct-fill .red {
  color: #ff5c5c;
}
.answer-desc {
  font-size: 14px;
  color: #666;
  white-space: pre-line;
  margin-top: 10px;
}
.answer-box p {
  display: block;
  font-size: 14px;
  color: #666;
  padding: 10px 0;
  line-height: 1.6;
}

.blank-text {
  padding-right: 10px;
}

.upload-box {
  position: relative;
  width: 70px;
  height: 70px;
  overflow: hidden;
  margin-top: 15px;
}
.choose-img-box {
  width: 70px;
  height: 70px;
  position: relative;
  background-color: #f2f2f7;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #999999;
  margin-top: 15px;
}

.choose-img-box .pic {
  width: 30px;
  height: 30px;
}

.choose-img-box .choose-img-desc {
  margin-top: 4px;
}
.upload-box .pre-img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 0px 0px 2px 2px;
  vertical-align: top;
}
.upload-box .btn-delete {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.42);
  border-radius: 0px 0px 2px 2px;
  color: #fff;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  text-align: center;
}
.correct-fill-content {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
.correct-fill-content .grey {
  color: #666;
  font-size: 14px;
}
.videos img {
  width: 100%;
  margin-bottom: 10px;
}
.videos-item {
  width: 100%;
  height: 230px;
  margin-bottom: 10px;
}
/* confirm-dialog */
.confirm-header {
  font-size: 17px;
  padding: 10px 0 15px;
}
.confirm-bd {
  text-align: center;
  color: #666;
}
.confirm-footer {
  margin: 25px -15px -15px;
  width: 290px;
  height: 50px;
  display: flex;
  align-items: center;
  border-top: 1px solid #e0e0e0;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  line-height: 50px;
  font-weight: bold;
  font-size: 16px;
}
.confirm-ok {
  color: #1890ff;
}
.remove-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}
#doWrapper .mask {
  z-index: 98;
}
.card-wrap {
  font-size: 15px;
  // background: #f2f2f7;
  padding: 15px 0 100px;
  position: absolute;
  margin: 0 auto;
  max-width: 500px;
  min-width: 320px;
  width: 100%;
  padding-bottom: 130px;
  box-sizing: border-box;
  .card-content {
    border-radius: 4px;
    background: #fff;
    margin: 0 15px;
    box-sizing: border-box;
    padding:15px 0;
  }
  .card-head {
    font-weight: 700;
    font-size: 19px;
    line-height: 26px;
    padding: 15px;
    background: #ffffff;
    margin: 0 15px 10px;
    border-radius: 4px;
  }
  .card-content {
    .item-title {
      font-weight: 700;
      line-height: 22px;
      margin-bottom: 10px;
      span {
        margin-left: 5px;
        font-weight: initial;
      }
    }
  }
  .card-item {
    margin: 0 15px 25px;
    background: #ffffff;
  }
  .card-item:last-child {
    margin-bottom: 0;
  }
  .card-opt-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .card-opt-item {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 78px;
    }
  }
  .card-checkbox {
    width: 16px;
    height: 16px;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 2px;
    box-sizing: border-box;
    margin-right: 10px;
    display: inline-block;
  }
  .card-checkbox.active {
    border: 5px solid #1890ff;
  }
  .card-radio {
    width: 17px;
    height: 17px;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 50%;
    box-sizing: border-box;
    margin-right: 10px;
    display: inline-block;
  }
  .card-radio.active {
    border: 5px solid #1890ff;
  }
}
.foot-card-imgs {
  position: fixed;
  background-color: #fff;
  bottom: 61px;
  text-align: center;
  z-index: 101;
  max-width: 500px;
  min-width: 320px;
  width: 100%;
  box-shadow: 0px -3px 0 rgba(0, 0, 0, 0.015);
  border-radius: 10px 10px 0px 0px;
}
.foot-card-imgs .top {
  text-align: center;
  padding: 10px;
  font-size: 13px;
  color: #999999;
}
.card-toggle-icon {
  width: 8px;
  height: 12px;
  display: block;
  margin: 0 auto;
  transform: rotate(-90deg);
  transition: 0.3s all ease;
  margin-bottom: 3px;
}
.card-toggle-icon.active {
  transform: rotate(-270deg);
}
.banner {
  margin: 0 20px;
  height: 190px;
}
.my-swipe {
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.fillred {
  color: #ff5c5c !important;
}
.fillgreen {
  color: #00cf97 !important;
}

.single_limit {
  text-align: center;
  margin-top: 15px;
}

.limit_time {
  display: flex;
  justify-content: center;
  align-items: center;
}

.limit_time_part {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
}
.limit_time .limit_time_part:nth-child(1),
.limit_time .limit_time_part:nth-child(3),
.limit_time .limit_time_part:nth-child(5) {
  background: #f2f2f7;
  border-radius: 4px;
}
.limit_time .limit_time_part:nth-child(2),
.limit_time .limit_time_part:nth-child(4) {
  width: 15px;
}
.single_time_desc {
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  margin: 2px 0 20px;
}
.blank-item {
  display: inline-block;
}
.f48{
  font-size: 24px !important;
}
.f44 {
  font-size: 22px !important;
}
.f32 {
  font-size: 16px !important;
}
.pbno {
  padding-bottom: 0;
}
.mbmore {
  margin-bottom: 40px !important;
}
.borderCircle {
  border-radius: 50% !important;
}
.other-fill {
  border: 1px solid #eee;
  background-color: #fafafa;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  padding: 10px 15px;
  margin-top: 10px;
}
.confirm-foot {
  display: flex;
  align-items: center;
}
.confirm-foot .foot-btn {
  display: flex;
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  background: #1890FF;
  color: #FFFFFF;
  flex: 1;
}
.confirm-foot .foot-cancel {
  background: #F8F8F8;
  color: #262626;
  margin-right: 10px;
}
.confirm-text {
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  background: #F8F8F8;
  border-radius: 4px;
  margin-bottom: 20px;
}
.unfinished-count {
  color: #FF0000;
  margin-left: 3px;
}
.nickedit{
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890FF;
  margin-left: 2px;
  min-width: 55px;
}
.edit-icon {
  width: 18px;
  height: 18px;
  object-fit: cover;
  margin-right: 5px;
}
.minProgram-panel {
  width: 100%;
  position: fixed;
  z-index: 102;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.form-container {
  width: 100%;
  max-width: 500px;
  padding: 20px 15px 15px;
  background-color: #ffffff;
  border-radius: 4px 4px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.form-container.nopd {
  padding: 0
}
.form-box {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.name-box {
  flex:1;
}
.avatar-icon {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 4px;
  margin-right: 10px;
  object-fit: cover;
}
.name-box {
  display: flex;
  align-items: center;
}
.submit-form {
  height: 45px;
  background-color: #1890FF;
  color: #fff;
  font-size: 18px;
  margin: 20px 15px 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fill-title {
  padding: 20px 15px;
  font-size: 15px;
  font-weight: bold;
}
.edit-info {
  height: 29px;
  font-size: 13px;
  color: #FB7417;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #FFF1E5;
}
.edit-info-icon {
  margin-right: 5px;
}
.edit-tip {
  color: #999999;
  font-size: 14px;
  margin-bottom: 20px;
}
.fill-box {
  max-height: calc(100vh - 70px);
  overflow-y: auto;
}
.edit-info-icon {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-flex;
  background: #FB7417;
  font-size: 12px;
  color: #fff;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/normal/do.vue